import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
import Button from '../button';
import SvgRenderer from '../svg-renderer';
const StyledContainer = styled.View`
  flex-direction: column;
  justify-content: center;
`;
const CenteredTextContainer = styled.View`
  flex-direction: column;
  align-items: center;
  letter-spacing: ${props => props.type === 'illustration' ? '0.25px' : 0};
`;
const StyledBodyText = styled(Text.BodySmall)`
  margin-bottom: 10px;
  margin-top: 13px;
`;
const StyledIllustration = styled.View`
  position: relative;
  max-width: 50%;
  bottom: ${props => props.bottom}px;
  right: ${props => props.right}px;
  z-index: -1;
`;
const GROUP_TYPES = {
  simple: {
    title: Text.BodyBase,
    titleColor: Colors.gray500,
    spacer: 'f16'
  },
  list: {
    title: Text.H6,
    titleColor: Colors.gray600,
    spacer: 'f24',
    buttonType: 'secondary'
  },
  illustration: {
    title: Text,
    titleColor: Colors.gray600,
    titleSize: 18,
    titleFont: 'LarsseitMedium',
    titleLineHeight: 24,
    spacer: 'f24'
  }
};
export default function Group(props) {
  const groupType = GROUP_TYPES[props.type];
  const TitleText = groupType.title;
  return /*#__PURE__*/React.createElement(StyledContainer, {
    style: [props.type !== 'simple' && styles.whiteBackground, props.type === 'list' && styles.borderRadius, props.type === 'illustration' && styles.rowContainer]
  }, /*#__PURE__*/React.createElement(View, {
    style: styles[props.type]
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(CenteredTextContainer, {
    type: props.type
  }, /*#__PURE__*/React.createElement(TitleText, {
    type: props.type,
    color: groupType.titleColor,
    size: groupType.titleSize,
    fontFamily: groupType.titleFont,
    lineHeight: groupType.titleLineHeight,
    styles: [styles[props.type].title, props.type === 'illustration' && styles.illustrationTitle]
  }, props.title)), props.type === 'list' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledBodyText, {
    color: Colors.gray600
  }, props.body), props.list.map((obj, i) => /*#__PURE__*/React.createElement(View, {
    key: i
  }, /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray600
  }, "\u2022", '   ', obj))), /*#__PURE__*/React.createElement(Spacer, {
    size: "f6",
    height: true
  }))), /*#__PURE__*/React.createElement(Spacer, {
    size: groupType.spacer,
    height: true
  }), /*#__PURE__*/React.createElement(Button, {
    onPress: props.button.onPress,
    type: groupType.buttonType
  }, props.button.label)), props.type === 'illustration' && /*#__PURE__*/React.createElement(StyledIllustration, {
    right: props.illustration.right,
    bottom: props.illustration.bottom
  }, /*#__PURE__*/React.createElement(SvgRenderer, {
    source: props.illustration.source,
    height: props.illustration.height,
    width: props.illustration.width
  })));
}
const buttonShape = {
  label: PropTypes.string,
  onPress: PropTypes.func
};
const illustrationShape = {
  source: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.number,
  width: PropTypes.number,
  bottom: PropTypes.number,
  right: PropTypes.number
};
Group.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  button: PropTypes.shape(buttonShape),
  illustration: PropTypes.shape(illustrationShape),
  type: PropTypes.oneOf(Object.keys(GROUP_TYPES)),
  list: PropTypes.array
};
Group.defaultProps = {
  title: '',
  body: '',
  button: {
    label: '',
    onPress: () => {}
  },
  illustration: {
    source: '',
    height: 0,
    width: 0,
    bottom: 0,
    right: 0
  },
  type: 'simple',
  list: []
};
const styles = {
  whiteBackground: {
    backgroundColor: Colors.white,
    overflow: 'hidden'
  },
  borderRadius: {
    borderRadius: 10
  },
  rowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    maxHeight: 202
  },
  illustration: {
    minWidth: 175,
    maxWidth: '46.67%',
    paddingTop: 40,
    paddingBottom: 50,
    marginLeft: 24,
    title: {
      textAlign: 'left'
    }
  },
  list: {
    padding: 24,
    paddingBottom: 32,
    title: {
      textAlign: 'center'
    }
  },
  simple: {
    title: {
      textAlign: 'center'
    }
  }
};
//# sourceMappingURL=group.js.map